// filtersSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  company: null,
  category: null,
  subcategory: null,
  sort_by: null,
  length_min: null,
  length_max: null,
  weight_min: null,
  weight_max: null,
  search: '',
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setPriceRange: (state, action) => {
      state.min = action.payload.min;
      state.max = action.payload.max;
      if (action.payload.subcategory !== undefined) state.subcategory = action.payload.subcategory;
    },
    clearFilteredProducts: (state) => {
      state.data = [];
    },
    setCompany: (state, action) => {
      state.company = action.payload.company !== undefined ? action.payload.company : action.payload;
      if (action.payload.subcategory !== undefined) state.subcategory = action.payload.subcategory;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setSubcategory: (state, action) => {
      state.subcategory = action.payload;
    },
    setSort: (state, action) => {
      const sortValue = action.payload.sort !== undefined ? action.payload.sort : action.payload;
      state.sort_by = sortValue;
      if (action.payload.subcategory !== undefined) state.subcategory = action.payload.subcategory;
    },
    setLengthRange: (state, action) => {
      state.length_min = action.payload.min;
      state.length_max = action.payload.max;
      if (action.payload.subcategory !== undefined) state.subcategory = action.payload.subcategory;
    },
    setWeightRange: (state, action) => {
      state.weight_min = action.payload.min;
      state.weight_max = action.payload.max;
      if (action.payload.subcategory !== undefined) state.subcategory = action.payload.subcategory;
    },
    setSearchFilter: (state, action) => {
      state.search = action.payload.search !== undefined ? action.payload.search : action.payload;
      if (action.payload.subcategory !== undefined) state.subcategory = action.payload.subcategory;
    },
  },
});

export const {
  setPriceRange,
  setCompany,
  setCategory,
  setSubcategory,
  setSort,
  setLengthRange,
  setWeightRange,
  setSearchFilter,
  clearFilteredProducts,
} = filtersSlice.actions;

export default filtersSlice.reducer;
